<template>
  <div class="container">
		<div class="nav-layout">
			<div class="nav-tab">
				<div class="tab" :class="{'tab-active': tabIndex == 0}" @click="tabIndex = 0">
					<img v-if="tabIndex == 0" src="./assets/watch_active_icon.svg" alt="">
					<img v-else src="./assets/watch_icon.svg" alt="">
					搜索订单
				</div>
				<img style="width: 16px; height: 16px;" src="./assets/arrow_icon.png" alt="">
				<div class="tab" :class="{'tab-active': tabIndex == 1}">
					<img v-if="tabIndex == 1" src="./assets/edit_active_icon.svg" alt="">
					<img v-else src="./assets/edit_icon.svg" alt="">
					报案信息
				</div>
			</div>
		</div>
		<div v-if="tabIndex == 0">
			<div class="filter-box block">
				<van-form validate-first>
					<div class="item" style="position: relative;">
						<van-field
							label="投保时间"
							placeholder=""
							@click="chooseDateRangeFlag = true"
							readonly
						/>
						<div @click="chooseDateRangeFlag = true" class="date-remind">
							<img src="./assets/calendar_icon.png" alt="" style="width: 11px; height: 14px;">
							<div class="remind-unit">{{ reqParams.startDate ? moment(reqParams.startDate).format('YYYY-MM-DD') : '开始日期' }}</div>
							<span style="color: #333;">至</span>
							<div class="remind-unit">{{ reqParams.endDate ? moment(reqParams.endDate).format('YYYY-MM-DD') : '结束日期' }}</div>
						</div>
					</div>
					<div>
						<van-field v-model.trim="reqParams.name" label="人员姓名" placeholder="请输入被保险人姓名"/>
					</div>
					<!-- <div>
						<van-field v-model.trim="reqParams.idType" label="证件类型" placeholder="请选择证件类型" @click="showChooseIdType()" readonly right-icon="arrow-down"/>
					</div> -->
					<div>
						<van-field v-model.trim="reqParams.idCode" label="证件号码" placeholder="请输入被保险人证件号码"/>
					</div>
				</van-form>
				<div class="search-box">
					<van-button class="btn" type="primary" block @click="searchList()">搜索</van-button>
					<!-- <van-button v-if="orderList && orderList.length > 1" class="extra-btn" plain block @click="batchReport()">批量报案</van-button> -->
				</div>
			</div>
			<div class="order-list" v-if="orderList && orderList.length > 0 && !loadingFlag">
				<div class="order-item" v-for="(item, idx) in orderList" :key="idx">
					<div class="item-top">
						<div class="top-left">订单号：{{ item.tradeNo }}</div>
						<div class="top-right">状态：{{ getStatusName(item.status) }}</div>
						<!-- <div class="top-left">
							<van-checkbox v-model="item.checked" :disabled="item.disabled" icon-size="13px" style="margin-right: 4px;" @click="updateCheckStatus(item)"></van-checkbox>
							<span style="font-size: 12px;">订单号：{{ item.tradeNo }}</span>
						</div>
						<div class="top-right">{{ getStatusName(item.status) }}</div> -->
					</div>
					<div class="item-middle">
						<img class="middle-left" src="http://fimage.huaxiyou.cc/upload/image/20210408/1617847731129078130.jpg" alt="">
						<div class="middle-right">
							<div style="color: #333;">{{ item.title }}</div>
							<div>被保人：{{ getInsuredNames(item.togetherInfos) }}</div>
							<div>投保时间：{{ item.createTime ? moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</div>
							<div v-if="item.startDate && item.endDate">保障期限：{{ moment(item.startDate).format("YYYY-MM-DD HH:mm:ss") }}至{{ moment(item.endDate).format("YYYY-MM-DD HH:mm:ss") }}</div>
						</div>
					</div>
					<div class="item-bottom">
						<van-button class="btn" type="primary" block @click="goReport(item)">去报案</van-button>
					</div>
				</div>
			</div>
			<div class="empty-data" v-else-if="!loadingFlag">
				暂无订单<br><span style="font-size: 13px; color: orange;">请检查姓名或证件号是否正确</span>
			</div>
		</div>
		<div v-else-if="tabIndex == 1">
			<div class="title-box block">
				<div class="left">保险产品</div>
				<div class="right">{{ currentOrder.title }}</div>
			</div>
			<div class="caution-box block">
				<div class="tip">理赔注意事项（重要）</div>
				<div class=""><text class="key">医院要求：</text>二级及二级以上的公立医院</div>
				<div class=""><text class="key">保险赔付范围：</text>保险按照社保目录进行报销，社保外的需自费（含自费产品除外）</div>
				<div class=""><text class="key">必备资料：</text>①病历      ②发票     ③费用明细     ④检查报告</div>
			</div>
			<div class="fill-box block">
				<van-form validate-first>
					<div class="section-title">出险人信息<span style="color: red;">（必填）</span></div>
					<div class="item">
						<van-field v-model.trim="infoForm.name" label="姓名" placeholder="请输入姓名" :readonly="!isDuty" :right-icon="personArray && personArray.length>1 ? 'arrow-down' : ''"  required />
						<div v-if="personArray && personArray.length>1" style="top: 0; left: 20%; width: 80%; height: 30px; position: absolute; z-index: 100;" @click="showChoosePerson()"></div>
					</div>
					<div class="item">
						<van-field v-model.trim="infoForm.idType" label="证件类型" placeholder="请选择证件类型" @click="showChooseIdType()" readonly :right-icon="isDuty? 'arrow-down' : ''" required />
					</div>
					<div class="item">
						<van-field v-model.trim="infoForm.idCode" label="证件号" placeholder="请输入证件号" :readonly="!isDuty" required />
					</div>
					<div class="item" style="margin-left: -8px;">
						<span style="color: red; margin-right: 2px;">*</span>
						<van-field v-model.trim="infoForm.phone" label="联系方式" placeholder="请输入联系方式" />
					</div>
				</van-form>
			</div>
			<div class="fill-box block">
				<van-form validate-first>
					<div class="section-title">理赔信息<span style="color: red;">（选填）</span></div>
					<div class="item">
						<van-field
							label="出险日期"
							value="请选择出险日期"
							placeholder="请选择出险日期"
							v-model.trim="infoForm.date"
							@click="chooseDateFlag = true"
							readonly
							right-icon="calender-o"
						/>
					</div>
					<div class="item">
						<div class="label">出险地点</div>
						<div style="margin-top: 8px; width: 100%;">
							<div style="display: flex; border: 0.5px solid #eee; padding: 0 8px; border-radius: 3px;">
								<van-field style="width: 70px; margin-right: 8px;" v-model.trim="infoForm.addressType" label="" placeholder="" @click="showChooseAddressType()" readonly right-icon="arrow-down"/>
								<van-field v-if="infoForm.addressType == '境内'" v-model.trim="infoForm.address" label="" placeholder="请选择地区" @click="showChooseArea()" readonly right-icon="arrow-down"/>
							</div>
							<div style="margin: 8px auto; border: 0.5px solid #eee; padding: 0 8px; border-radius: 3px; width: 100%; box-sizing: border-box;">
								<van-field type="textarea" :autosize="{minHeight: 80}" v-model.trim="infoForm.addressDetail" label="" placeholder="请填写具体地址"/>
							</div>
						</div>					
					</div>
					<div class="item" style="border-bottom: none;">
						<div class="label">出险经过</div>
						<div style="margin: 8px auto; border: 0.5px solid #eee; padding: 0 8px; border-radius: 3px; width: 100%; box-sizing: border-box;">
							<van-field 
								type="textarea" 
								:autosize="{minHeight: 120}" 
								v-model.trim="infoForm.accidentProcess" 
								label="" 
								placeholder="填写样例:2024年1月30日上午12时左右，在合肥市参加户外活动时爱伤，目前在安徽医料大学第一附属医院（三甲公立医院)就诊，医生诊断为左脚软组织挫伤，一周后复查。"/>
						</div>
					</div>
				</van-form>
			</div>
			<div class="fill-box block">
				<van-form validate-first>
					<div class="item" style="border-bottom: none;">
						<div class="label">医疗费由谁支付</div>
						<div style="margin: 8px 0px 8px 12px; border: 0.5px solid #eee; padding: 0 8px; border-radius: 3px; width: 100%; box-sizing: border-box;">
							<van-field v-model.trim="medicalPaymentTypeName" label="" placeholder="请选择" @click="showChoosePayType()" readonly right-icon="arrow-down"/>
						</div>
					</div>
					<div class="item" style="border-bottom: none;">
						<!-- <div class="label"><span style="color: red; margin-right: 2px;">*</span>活动类型</div> -->
						<div class="label">活动类型</div>
						<div style="margin: 8px 0px 8px 12px; border: 0.5px solid #eee; padding: 0 8px; border-radius: 3px; width: 100%; box-sizing: border-box; display: flex; align-items: center;">
							<van-field :style="{'width': infoForm.activityType == '其他' ? '66px' : 'inherit'}" v-model.trim="infoForm.activityType" label="" placeholder="请选择" @click="showChooseActivityType()" readonly right-icon="arrow-down"/>
							<van-field v-if="infoForm.activityType == '其他'" v-model.trim="customActivityType" maxlength="20" style="margin-left: 6px;" placeholder="请填写活动类型"></van-field>
						</div>
					</div>
					<div class="item" style="border-bottom: none;">
						<div class="label">受伤原因</div>
						<div style="margin: 8px 0px 8px 12px; border: 0.5px solid #eee; padding: 0 8px; border-radius: 3px; width: 100%; box-sizing: border-box; display: flex; align-items: center;">
							<van-field :style="{'width': infoForm.reasonForInjury == '其他' ? '70px' : 'inherit'}" v-model.trim="infoForm.reasonForInjury" label="" placeholder="请选择" @click="showChooseReasonType()" readonly right-icon="arrow-down"/>
							<van-field v-if="infoForm.reasonForInjury == '其他'" v-model.trim="customReasonType" maxlength="20" style="margin-left: 6px;" placeholder="请填写受伤原因"></van-field>
						</div>
					</div>
				</van-form>
			</div>
			<div class="btn-box">
				<van-button class="btn" type="primary" block @click="startSubmit()">提交</van-button>
			</div>
		</div>
    
		<!-- 选择投保时间 -->
		<van-calendar :default-date="defaultDateRange" :min-date="searchMinDate" v-model="chooseDateRangeFlag" type="range" max-range="15" @confirm="confirmCalendar" />
	
		<!-- 选择证件类型 -->
		<van-popup v-model="chooseIdTypeFlag" round position="bottom" :style="{ height: '30%' }">
			<van-picker
				title="选择证件类型"
				show-toolbar
				:columns="idTypeOptions"
				@confirm="confirmIdType"
				@cancel="chooseIdTypeFlag = false"
			/>
		</van-popup>

		<!-- 查询出险人 -->
		<van-popup v-model="choosePersonFlag" round position="bottom" :style="{ height: '30%' }">
			<van-search style="position: absolute; top: -8px; right: 60px; left: 60px; z-index: 100;" v-model="searchKey" placeholder="请输入搜索关键词" />
			<van-picker
				title=""
				:show-toolbar="true"
				:columns="filterPersons"
				@confirm="confirmPerson"
				@cancel="choosePersonFlag = false"
			/>
		</van-popup>

		<!-- 选择出险日期 -->
		<van-popup v-model="chooseDateFlag" position="bottom">
			<van-datetime-picker
				type="datetime"
				title="选择出险日期"
				@confirm="onConfirmDate"
				:min-date="pickMinDate"
				:max-date="pickMaxDate"
				:formatter="formatter"
				v-model="currentDate"
				@cancel="chooseDateFlag = false"
			/>
		</van-popup>
		
		<!-- 选择境内/境外 -->
		<van-popup v-model="chooseAddressTypeFlag" round position="bottom" :style="{ height: '30%' }">
			<van-picker
				title=""
				show-toolbar
				:columns="addressTypeOptions"
				@confirm="confirmAddressType"
				@cancel="chooseAddressTypeFlag = false"
			/>
		</van-popup>

		<!-- 选择地区 -->
		<van-popup v-model="chooseAreaFlag" round position="bottom" :style="{ height: '50%' }">
			<van-picker
				v-model="currentArea"
				title="选择地区"
				show-toolbar
				:columns="areaList"
				@change="changeAreaPick"
				@confirm="confirmAreaPick"
				@cancel="cancelAreaPick"
			/>
    </van-popup>

		<!-- 选择付款方式 -->
		<van-popup v-model="choosePayTypeFlag" round position="bottom" :style="{ height: '30%' }">
			<van-picker
				title=""
				show-toolbar
				:columns="payTypeOptions.map(item => item.label)"
				@confirm="confirmPayType"
				@cancel="choosePayTypeFlag = false"
			/>
		</van-popup>

		<!-- 选择活动类型 -->
		<van-popup v-model="chooseActivityTypeFlag" round position="bottom" :style="{ height: '30%' }">
			<van-picker
				title=""
				show-toolbar
				:columns="activityTypeOptions"
				@confirm="confirmActivityType"
				@cancel="chooseActivityTypeFlag = false"
			/>
		</van-popup>

		<!-- 选择受伤原因 -->
		<van-popup v-model="chooseReasonTypeFlag" round position="bottom" :style="{ height: '30%' }">
			<van-picker
				title=""
				show-toolbar
				:columns="reasonTypeOptions"
				@confirm="confirmReasonType"
				@cancel="chooseReasonTypeFlag = false"
			/>
		</van-popup>

	</div>
</template>

<script>
import moment from "moment";
import util from "@/libs/util.js";
import axios from "axios";
// import regionWindow from '@/components/region-window/index.vue'
import {
	Area,
	Calendar,
  Rate,
  Button,
  Tab,
  Tabs,
  Popup,
  Field,
  DatetimePicker,
  Icon,
  Picker,
  Toast,
  Checkbox,
  CheckboxGroup,
  Form,
  Dialog,
  RadioGroup,
  Radio,
  PasswordInput,
	Search,
  NumberKeyboard,
  Loading
} from "vant";

export default {
	components:{ 
		[Area.name]: Area,
		[Calendar.name]: Calendar,
		[Rate.name]: Rate,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Form.name]: Form,
    [Dialog.Component.name]: Dialog.Component,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [PasswordInput.name]: PasswordInput,
		[Search.name]: Search,
    [NumberKeyboard.name]: NumberKeyboard,
    [Loading.name]: Loading, 
	},
	data() {
		return {
		  moment: moment,
		  util: util,
			tabIndex: 0,
			loadingFlag: true,
			reqParams: {
				startDate: '',
				endDate: '',
				name: '',
				idType: '',
				idCode: '',
				pageNumber: 1,
				pageSize: 10,
			},
			orderList: [],
		  caseId: '',
		  orderId: '',
		  infoForm: {
				name: '',
				idType: '',
				idCode: '',
				phone: '',
				date: '',
				addressType: '境内',
				address: '',
				addressDetail: '',
				accidentProcess: '',
				activityType: '',
				reasonForInjury: '',
				medicalPaymentType: '',
		  },
		  insureError: {},
		  choosePersonFlag: false,
		  chooseIdTypeFlag: false,
		  idTypeOptions: ["身份证", "护照", "其他"],
		  addressTypeOptions: ["境内", "境外"],
		  chooseDateFlag: false,
		  minDate: new Date().getTime() - 24 * 3600 * 1000 * 365 * 5,
		  maxDate: new Date().getTime(),
		  addressInfo: {
			  provinceName: '',
			  cityName: '',
			  countyName: '',
			  provinceCode: '',
			  cityCode: '',
			  countyCode: '',
		  },
		  chooseAddressTypeFlag: false,
		  productName: '',
		  personOptions: [],
		  personArray: [],
		  currentPerson: {},
		  insuranceCode: '',
		  pageShow: false,
		  showDatePick: false,
		  isDuty: false, //是否是责任险订单
			filterPersons: [],
			searchKey: '',
			pickMinDate: new Date(2020, 0, 1),
			pickMaxDate: new Date(),
			currentDate: new Date(),
			chooseAreaFlag: false,
			areaList: [{values: [], defaultIndex: 0}, {values: [], defaultIndex: 0}, {values: [], defaultIndex: 0}],
			currentArea: '',
			choosePayTypeFlag: false,
			payTypeOptions: [
				{label: "机构垫付", value: 1}, 
				{label: "部分机构垫付，后续伤者自己付费", value: 2}, 
				{label: "伤者自己付费", value: 3}
			],
			showCalendar: false,
			chooseDateRangeFlag: false,
			defaultDateRange: [],
			searchMinDate: new Date(2020, 0, 1),
			currentOrder: {},
			medicalPaymentTypeName: '', 
			chooseActivityTypeFlag: false,
			activityTypeOptions: ["骑马", "徒步", "旅游", "登山", "营地", "亲子", "研学", "骑行", "其他"],
			customActivityType: "",
			chooseReasonTypeFlag: false,
			reasonTypeOptions: ["崴脚", "牙齿", "骨折", "感冒", "高反", "动物咬伤", "其他"],
			customReasonType: "",
			noMoreData: false,
		};
	},
	async mounted() {
		document.title = '理赔报案';
		// this.orderId = this.$route.query.orderId ? this.$route.query.orderId : '';
		// this.caseId = this.$route.query.caseId ? this.$route.query.caseId : '';
		// this.isDuty = this.$route.query.isDuty ? true : false;
		
		this.reqParams.endDate = new Date().getTime();
		this.reqParams.startDate = new Date().setHours(0, 0, 0, 0) - 14*24*3600*1000;
		this.defaultDateRange = [new Date(this.reqParams.startDate), new Date(this.reqParams.endDate)];
		await this.getCitys('', 1);
		await this.getCitys(this.areaList[0].values[0].value, 2);
		await this.getCitys(this.areaList[1].values[0].value, 3);
		window.addEventListener('scroll', this.scroll);		

		// if(this.orderId){
		// 	if(this.isDuty){
		// 		this.getDutyOrderData();
		// 	}else{
		// 		this.getOrderData();
		// 	}
		// }else{
		// 	if(this.caseId){
		// 		this.getCaseData()
		// 	}
		// }
	},
	watch: {
		showDatePick(newValue, oldValue) {
			setTimeout(() =>  {
				this.pageShow = newValue;
			}, 100);
		},
		searchKey: {
			handler(val){
				this.filterPersons = [];
				if(val && val.trim()){
					this.searchKey = val.trim();
					this.personArray.forEach(item => {
						if(item.n.includes(this.searchKey)){
							this.filterPersons.push({
								text: item.n,
								value: item.i,
							})
						}
					});
				}else{
					this.personArray.forEach(item => {
						this.filterPersons.push({
							text: item.n,
							value: item.i,
						})
					});
				}
			},
			deep: true,
		}
	},
	beforeDestroy: function() {
    window.removeEventListener('scroll', this.scroll)
  },
	methods: {
		formatter(type, value){
			if (type === 'year') {
      	return value;
      } else if (type === 'month') {
        return `${value}月`;
      } else if (type === 'day') {
        return `${value}日`;
      } else if (type === 'hour') {
        return `${value}时`;
      } else if (type === 'minute') {
        return `${value % 60}分`;
      }
      return value;
		},
		getInsuredNames(togetherInfos){
			try {
				let persons = JSON.parse(togetherInfos);
				if(persons.length > 0){
					return persons.length > 1 ? persons[0].n+'等'+persons.length+'人' : persons[0].n;
				}else{
					return '';
				}
			} catch (error) {
				return '';
			}
		},
		getStatusName(status){
			let s = parseInt(status);
			switch(s){
				case 0: return '待支付';
				case 1: return '已支付';
				case 2: return '已退保';
				case 5: return '暂存单';
				case 10: return '正在出单';
				case 11: return '已删除';
				case 14: return '已退款';
			}
		},
		confirmCalendar(e){
			if(e && e.length == 2){
				this.reqParams.startDate = e[0].getTime();
				this.reqParams.endDate = e[1].getTime() + (24*3600-1)*1000;
			}
			this.chooseDateRangeFlag = false;
		},
		updateCheckStatus(item){
			if(item.disabled){
				return;
			}
			let checkedItems = [];
			for (const orderItem of this.orderList) {
				if(orderItem.checked){
					checkedItems.push(orderItem);
				}
			}
			if(checkedItems.length <= 0){
				for (const orderItem of this.orderList) {
					orderItem.disabled = false;
				}	
			}else{
				let intersectStart = checkedItems[0].startDate, intersectEnd = checkedItems[0].endDate;
				for (const element of checkedItems) {
					intersectStart = Math.max(element.startDate, intersectStart);	
					intersectEnd = Math.min(element.endDate, intersectEnd);
				}
				for (const orderItem of this.orderList) {
					if(!orderItem.checked){
						let newStart = Math.max(orderItem.startDate, intersectStart);
						let newEnd = Math.min(orderItem.endDate, intersectEnd);
						this.$set(orderItem, 'disabled', newStart > newEnd ? true : false)
					}
				}
			}
		},
		async searchList(){
			if(this.reqParams.name.length <= 0){
				this.$toast("请填写人员姓名");
				return;
			}
			// if(this.reqParams.idType.length <= 0){
			// 	this.$toast("请选择证件类型");
			// 	return;
			// }
			if(this.reqParams.idCode.length <= 0){
				this.$toast("请填写证件号码");
				return;
			}
			// else{
			// 	if(this.reqParams.idType == '身份证'){
			// 		if(!util.isCardID(this.reqParams.idCode)){
			// 			this.$toast("证件号码有误");
			// 			return;
			// 		}
			// 	} 
			// }
			const LOADING = Toast.loading({
        message: '查询中...',
        forbidClick: true,
        loadingType: 'spinner',
				duration: 15000,
      });
			this.loadingFlag = true;
			this.reqParams.pageNumber = 1;
			await this.getOrderList();
			LOADING.clear();
			this.loadingFlag = false;
		},
		async getOrderList(){
			let res = await this.$http.post("/api/bill/getBillsByCaseInfo", this.reqParams);
			if(res.code == 0){
				if(this.reqParams.pageNumber == 1){
					this.orderList = [];
				}
				this.orderList = [...this.orderList, ...res.t];
				if(!res.t || res.t.length < this.reqParams.pageSize){
					this.noMoreData = true;
				}
				this.reqParams.pageNumber++;
			}else{
				if(res.msg){
					this.$toast.fail(res.msg);
				}
			}
		},
		goReport(item){
			let nowTime = new Date().getTime();
			if(nowTime < item.startDate){
				Dialog.confirm({
					title: "提示",
					message: '当前时间未在保障期限内，暂不支持报案',
					confirmButtonText: "知道了",
					showCancelButton: false,
				}).then(() => {
					
				}).catch(() => {});
				return;
			}
			this.orderId = item.id;
			this.isDuty = false;
			this.insuranceCode = item.insuranceCode;
			if(item.togetherInfos){
				try{
					this.personArray = JSON.parse(item.togetherInfos);
				}catch(e){
					//TODO handle the exception
				}
				if(this.personArray.length > 0){
					this.currentPerson = this.personArray[0];
					this.updateFillPerson();
				}
			}
			this.verifySupportReport(() => {
				this.infoForm.date = '';
				this.tabIndex = 1;
				this.currentOrder = item;
				document.documentElement.scrollTop = 0;
			})	
		},
		batchReport(){
			let selectedRows = [];
			for (const item of this.orderList) {
				if(item.checked){
					selectedRows.push(item);
				}	
			}
			//待完成...
		},
		getCitys(code, level){
			return new Promise((resolve, reject) => {
				axios.post("/api/address/getList", {code: code, level: level})
					.then((res) => {
						if(res.code == 0){
							if(level == 1){
								let provinces = [];
								res.t.forEach(item => {
									provinces.push({
										text: item.codeName,
										value: item.code,
									})
								})
								this.areaList[0].values = provinces;
							}else if(level == 2){
								let citys = [];
								res.t.forEach(item => {
									citys.push({
										text: item.codeName,
										value: item.code,
									})
								})
								this.areaList[1].values = citys;
							}else if(level == 3){
								let districts = [];
								res.t.forEach(item => {
									districts.push({
										text: item.codeName,
										value: item.code,
									})
								})
								this.areaList[2].values = districts;
							}
						}
						resolve(res);
					})
					.catch((err) => {
            if(err && err.msg){
              reject(err.msg);
            }else{
							reject('数据获取失败');
						}
          });
			})
		},
		async changeAreaPick(picker, values){
			if(values[0]){
				await this.getCitys(values[0].value, 2);
			}
			if(values[1]){
				await this.getCitys(values[1].value, 3);
			}else{
				let cityObj = this.areaList[1].values[0];
				await this.getCitys(cityObj.value, 3);
			}
			this.$forceUpdate();
		},
		// async getOrderData(){
		// 	let res = await this.$http.post("/api/bill/get", {id: this.orderId});
		// 	if(res.code == 0){
		// 		this.productName = res.t.title;
		// 		this.insuranceCode = res.t.insuranceCode;
		// 		if(res.t.togetherInfos){
		// 			try{
		// 				this.personArray = JSON.parse(res.t.togetherInfos);
		// 			}catch(e){
		// 				//TODO handle the exception
		// 			}
		// 			if(this.personArray.length > 0){
		// 				this.currentPerson = this.personArray[0];
		// 				this.updateFillPerson();
		// 			}
		// 		}
		// 		this.infoForm.date = 'this.moment(new Date().getTime()).format('YYYY-MM-DD HH:mm')';
		// 	}else{
		// 		if(res.msg){
		// 			this.$toast.fail(res.msg);
		// 		}
		// 	}
		// },
		// async getDutyOrderData(){
		// 	let res = await this.$http.post("/api/liabilityOrder/get", {id: this.orderId});
		// 	if(res.code == 0){
		// 		this.productName = res.t.title;
		// 		this.insuranceCode = res.t.insuranceCode;
		// 	}
		// },
		// async getCaseData(){
		// 	let res = await this.$http.post("/api/claim/getCaseInfo", {id: this.caseId});
		// 	if(res.code == 0){
		// 		let caseInfo = res.t;
		// 		this.isDuty = caseInfo.caseBillType == 1 ? true : false;
		// 		this.productName = caseInfo.productName;
		// 		this.insuranceCode = caseInfo.bill.insuranceCode;
		// 		this.infoForm.name = caseInfo.accidentName;
		// 		this.infoForm.idType = caseInfo.idType;
		// 		this.infoForm.idCode = caseInfo.idNo;
		// 		this.infoForm.phone = caseInfo.dockingContacts ? caseInfo.dockingContacts : caseInfo.affectedPersonPhone;
		// 		this.infoForm.date = moment(caseInfo.accidentTime).format('YYYY-MM-DD HH:mm');
		// 		this.infoForm.accidentProcess = caseInfo.accidentProcess;
		// 		this.infoForm.addressType = caseInfo.addressType == '2' ? '境外' : '境内';
		// 		if(caseInfo.accidentLocation){
		// 			try{
		// 				this.addressInfo = JSON.parse(caseInfo.accidentLocation);
		// 				this.infoForm.addressDetail = this.addressInfo.address;
		// 				if(this.addressInfo.provinceName){
		// 					this.infoForm.address = this.addressInfo.provinceName+this.addressInfo.cityName+this.addressInfo.countyName;
		// 				}
		// 			}catch(e){
		// 				//TODO handle the exception
		// 			}
		// 		}					
		// 	}
		// },
		isOther(idCode) {
			let newReg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
			let regs = /^[a-zA-Z]+$/;
			let other = new RegExp("[A-Za-z0-9]", "g"); //只需包含数字和英文
			let hasErr = true;
			if(idCode.length >= 5 && idCode.length <= 20) {
				if(!newReg.test(idCode)) {
					if(other.test(idCode) && !regs.test(idCode)) {
						hasErr = false;
					}
				}
			}
			if(hasErr) {
				return true;
			}else {
				return false;
			}
		},
		blurInsure(type, val, toast) {
		    if(type == "name") {
				let reg = /^[a-zA-Z\/ ]{2,20}$/;
				let regs_test = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/;
				if(val == "" || !val) {
					if(toast == true) {
						this.$toast("姓名未填写");
					}
					this.insureError.name = true;
					return true;
				}else if(val.length < 2) {
					if(toast == true) {
						this.$toast("姓名填写不完整");
					}
					this.insureError.name = true;
					return true;
				}else if (!regs_test.test(val)) {
					if(toast == true) {
						this.$toast("姓名格式不正确");
					}
					this.insureError.name = true;
					return true;
				}else {
					this.insureError.name = false;
					return false;
				}
		    }else if(type == "idType"){
				if(val == "") {
					if(toast == true) {
						this.$toast("请选择证件类型");
					}
					this.insureError.idType = true;
					return true;
				}else{
					this.insureError.idType = false;
					return false;
				}
			}else if(type == "idCode"){
				if(this.infoForm.idType == "身份证") {
					if(val == "") {
						if(toast == true) {
							this.$toast("证件号不能为空");
						}
						this.insureError.idCode = true;
						return true;
					}else if (!util.isCardID(val)) {
						if (toast == true) {
							this.$toast("证件号有误");
						}
						this.insureError.idCode = true;
						return true;
					}else {
						this.insureError.idCode = false;
						return false;
					}
				}else if (this.infoForm.idType == "护照") {
					let PassportNumberReg = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
					if(!PassportNumberReg.test(val)) {
						if(toast == true) {
							this.$toast("护照号码格式错误");
						}
						this.insureError.idCode = true;
						return true;
					}else {
						this.insureError.idCode = false;
						return false;
					}
				}else if (this.infoForm.idType == "其他") {
					let has = this.isOther(val);
					if(has) {
						if (toast == true) {
							this.$toast("证件号格式错误");
						}
						this.insureError.idCode = true;
						return true;
					}else {
						this.insureError.idCode = false;
						return false;
					}
				}else {
					this.insureError.idCode = false;
					return false;
				}
		    }else if(type == "phone"){
				if(!util.isPone(val)) {
					if(toast == true) {
						this.$toast("联系方式有误");
					}
					this.insureError.phone = true;
					return true;
				}else {
					this.insureError.phone = false;
					return false;
				}
			}else if(type == 'date'){
				if(val == "") {
					if(toast == true) {
						this.$toast("请选择日期");
					}
					this.insureError.date = true;
					return true;
				}else{
					this.insureError.date = false;
					return false;
				}
			}else if(type == 'addressType' || type == 'address' || type == 'addressDetail'){
				if(val == "") {
					if(toast == true) {
						this.$toast("出险地点请补充完整");
					}
					this.insureError.address = true;
					return true;
				}else{
					this.insureError.address = false;
					return false;
				}
			}else if(type == 'accidentProcess'){
				if(val == "") {
					if(toast == true) {
						this.$toast("请填写出险经过");
					}
					this.insureError.accidentProcess = true;
					return true;
				}else{
					this.insureError.accidentProcess = false;
					return false;
				}
			}
		},
		showChoosePerson(){
			this.searchKey = '';
			this.filterPersons = [];
			this.personArray.forEach(item => {
				this.filterPersons.push({
					text: item.n,
					value: item.i,
				})
			})
			this.choosePersonFlag = true;
		},
		confirmPerson(e){
			console.log('选中数据：', e)
			for (const person of this.personArray) {
				if(person.i == e.value){
					this.currentPerson = person;
					this.choosePersonFlag = false;
					this.updateFillPerson();
					break;
				}
			}
		},
		updateFillPerson(){
			this.infoForm.name = this.currentPerson.n;
			this.infoForm.idType = this.currentPerson.it;
			this.infoForm.idCode = this.currentPerson.i;
			this.infoForm.phone = this.currentPerson.m;
		},
		showChooseIdType(){
			if(this.tabIndex == 0){
				this.chooseIdTypeFlag = true;
			}else{
				this.chooseIdTypeFlag = this.isDuty ? true : false;
			}
		},
		confirmIdType(e){
			if(this.tabIndex == 0){
				this.reqParams.idType = e;
			}else{
				this.infoForm.idType = e;
			}
			this.chooseIdTypeFlag = false
		},
		showChooseAddressType(){
			this.chooseAddressTypeFlag = true
		},
		confirmAddressType(e){
			this.infoForm.addressType = e;
			this.chooseAddressTypeFlag = false
		},
		cancelAreaPick(){
			this.chooseAreaFlag = false;
		},
		confirmAreaPick(values){
			if(values && values.length >= 3){
				this.addressInfo.provinceName = values[0].text;
				this.addressInfo.provinceCode = values[0].value;
				this.addressInfo.cityName = values[1].text;
				this.addressInfo.cityCode = values[1].value;
				this.addressInfo.countyName = values[2].text;
				this.addressInfo.countyCode = values[2].value;
				this.infoForm.address = this.addressInfo.provinceName + this.addressInfo.cityName + this.addressInfo.countyName;
			}
			this.chooseAreaFlag = false;
		},
		showChooseDate(){
			this.chooseDateFlag = true
		},
		onConfirmDate(e){
			let timeStamp = e.getTime(); //毫秒
			this.infoForm.date = moment(timeStamp).format('YYYY-MM-DD HH:mm');
			this.chooseDateFlag = false;
		},
		showChooseArea(){
		  this.chooseAreaFlag = true;
		},
		showChoosePayType(){
			this.choosePayTypeFlag = true;
		},
		confirmPayType(e){
			this.medicalPaymentTypeName = e;
			for (const option of this.payTypeOptions) {
				if(option.label == this.medicalPaymentTypeName){
					this.infoForm.medicalPaymentType = option.value;
					break;
				}	
			}
			this.choosePayTypeFlag = false;
		},
		showChooseActivityType(){
			this.chooseActivityTypeFlag = true;
		},
		confirmActivityType(e){
			this.infoForm.activityType = e;
			this.chooseActivityTypeFlag = false;
		},
		showChooseReasonType(){
			this.chooseReasonTypeFlag = true;
		},
		confirmReasonType(e){
			this.infoForm.reasonForInjury = e;
			this.chooseReasonTypeFlag = false;
		},
		async verifySupportReport(callback){
			let res = await this.$http.post("/api/claim/reportACaseCheck", {
				orderType: this.isDuty ? 1 : 0,
				insuranceCode: this.insuranceCode,
				idNos: JSON.stringify([this.infoForm.idCode]),
			});
			if(res.code == 0){
				if(callback && typeof callback == 'function'){
					callback();
				}
			}else{
				if(res.msg){
					this.$toast.fail(res.msg);
				}
			}
		},
		async tempSave(type){
			let newForm = JSON.parse(JSON.stringify(this.getForm()));
			newForm.temporarily = type;
			if(this.caseId){
				newForm.caseId = this.caseId
			}
			let res = await this.$http.post("/api/claim/temporarilyStoreByClaimsAdd", newForm);
			if(res.code == 0){
				if(type == 1){
					this.$toast.success('提交成功')
				}else{
					this.$toast.success('暂存成功')
				}
				setTimeout(() => {
					uni.navigateBack();
				}, 1500);
			}else{
				if(res.msg){
					this.$toast.fail(res.msg);
				}
			}
		},
		startSubmit(){
			// if(!this.infoForm.activityType || this.infoForm.activityType.length <= 0){
			// 	this.$toast('请选择活动类型');
			// 	return;
			// }else{
			// 	if(this.infoForm.activityType == '其他' && this.customActivityType.length <= 0){
			// 		this.$toast('请填写活动类型');
			// 		return;
			// 	}
			// }
			// if(!this.infoForm.reasonForInjury || this.infoForm.reasonForInjury.length <= 0){
			// 	this.$toast('请选择受伤原因');
			// 	return;
			// }else{
			// 	if(this.infoForm.reasonForInjury == '其他' && this.customReasonType.length <= 0){
			// 		this.$toast('请填写受伤原因');
			// 		return;
			// 	}
			// }
			if(this.isDuty){
				if(!this.infoForm.name || this.infoForm.name.length <= 0){
					this.$toast('请填写出险人姓名');
					return;
				}
				if(!this.infoForm.idType){
					this.$toast('请选择出险人证件类型');
					return;
				}
				if(!this.infoForm.idCode || this.infoForm.idCode.length <= 0){
					this.$toast('请填写出险人证件号');
					return;
				}
			}else{
				if((!this.infoForm.name || this.infoForm.name.length <= 0) ||
					 (!this.infoForm.idType) || 
					 (!this.infoForm.idCode || this.infoForm.idCode.length <= 0)){
					Dialog.confirm({
            title: "提示",
            message: '出险人信息不完整，请联系客服处理（客服电话：4008-933-988）',
            confirmButtonText: "知道了",
            showCancelButton: false,
          }).then(() => {
              
          }).catch(() => {});
					return;
				}
			}
			if(!this.infoForm.phone || this.infoForm.phone.length <= 0){
				this.$toast('请填写出险人联系方式');
				return;
			}
			this.submit();
			// this.verifySupportReport(() => {
			// 	if(this.caseId){
			// 		this.tempSave(1);
			// 	}else{
			// 		this.submit();
			// 	}
			// })
		},
		getForm(){
			let personInfo = {
				n : this.infoForm.name,
				it: this.infoForm.idType,
				i: this.infoForm.idCode,
				m: this.infoForm.phone ? this.infoForm.phone : '',
			}
			let addressData = {
				address: this.infoForm.addressDetail ? this.infoForm.addressDetail : '',
			}
			if(this.infoForm.addressType == '境内'){
				addressData = {
					...addressData,
					...this.addressInfo
				}
			}
			let form = {
				billId: this.orderId,
				policyNo: this.insuranceCode,
				affectedPersons: JSON.stringify([personInfo]),
				accidentTime: this.infoForm.date ? new Date(this.infoForm.date).getTime() : '', 
				addressType: this.infoForm.addressType == '境外' ? 2 : 1,
				accidentLocation: JSON.stringify(addressData),
				accidentProcess: this.infoForm.accidentProcess ? this.infoForm.accidentProcess : '',
				billType: this.isDuty ? 1 : 0, //1责任险 0旅意险
				reportingSource: 6,
				medicalPaymentType: this.infoForm.medicalPaymentType ? this.infoForm.medicalPaymentType : '',
				activityType: this.infoForm.activityType,
				activityTypeDes: this.infoForm.activityType == '其他' && this.customActivityType ? this.customActivityType : '',
				reasonForInjury: this.infoForm.reasonForInjury,
				reasonForInjuryDes: this.infoForm.reasonForInjury == '其他' && this.customReasonType ? this.customReasonType : '',
			}
			return form;
		},
		async submit(){ 
			const LOADING = Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner',
				duration: 15000,
      });
			let res = await this.$http.post("/api/claim/caseAddNoToken", this.getForm());
			LOADING.clear();
			if(res.code == 0){
				Dialog.confirm({
					title: "提示",
					message: '提交成功',
					confirmButtonText: "确定",
					showCancelButton: false,
				}).then(() => {
					this.tabIndex = 0;
					// location.href = '/report';
				}).catch(() => {});
			}else{
				if(res.msg){
					Dialog.confirm({
						title: "提示",
						message: res.msg,
						confirmButtonText: "知道了",
						showCancelButton: false,
					}).then(() => {
						
					}).catch(() => {});
				}
			}
		},
		scroll() {
      let wScrollY = window.scrollY; // 滚动条位置
      let WInnerH = window.innerHeight // 设备窗口的高度
      var bScrollH = document.body.scrollHeight;  //  滚动条的总高度
      if ((wScrollY + WInnerH >= bScrollH-50) && !this.noMoreData) {
        this.getOrderList()
      }  
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .van-checkbox__icon--checked .van-icon{
	background-color: #00d385;
  border-color: #00d385;
}
::v-deep .van-cell{
	padding: 8px 0;
}
::v-deep .van-cell::after{
	border-bottom: none;
}
::v-deep .van-field__label{
	width: 80px !important;
}
.van-cell--required::before{
	left: -8px;
}

.container{
	background: #F5F5F5;
	padding-bottom: 80px;
	font-size: 16px;
	min-height: 100vh;
	box-sizing: border-box;
	.nav-layout{
		width: 100%;
		height: 60px;
		background: white;
		display: flex;
		justify-content: center;
		.nav-tab{
			margin-top: 10px;
			display: flex;
			align-items: center;
			background: rgba(243,246,249,1);
			height: 50px;
			justify-content: space-between;
			width: 88%;
			border-radius: 3px;
			.tab{
				display: flex;
				justify-content: center;
				align-items: center;
				width: 40%;
				font-size: 15px;
				font-weight: 500;
				color: #333;
				img{
					width: 15px;
					height: 15px;
					margin-right: 8px;
				}
			}
			.tab-active{
				color: #13AD7B;
			}
		}
	}
	.filter-box{
		padding: 12px 6% !important;
		.date-remind{
			position: absolute; 
			left: 80px; 
			right: 0px; 
			top: 0; 
			bottom: 0; 
			display: flex; 
			align-items: center; 
			font-size: 14px; 
			color: #C0C0C0;
			border: 0.5px solid #eee;
			padding: 0px 10px;
			border-radius: 3px;
			.remind-unit{
				width: 40%; 
				text-align: center;
				color: #333;
			}
		}
		.search-box{
			display: flex;
			justify-content: center;
			margin-top: 10px;
			width: 100%;
			position: relative;
			.btn{
				width: 100px;
				height: 30px;
				border: none;
				border-radius: 4px;
				background: rgba(19,173,123,1);
			}
			.extra-btn{
				position: absolute;
				right: 0px;
				width: 90px;
				height: 30px;
				color: rgba(19,173,123,1);
				border: 1px solid rgba(19,173,123,1);
				border-radius: 4px;
			}
		}
	}
	.order-list{
		margin-top: 8px;
		.order-item{
			margin: 8px 6px;
			border-radius: 4px;
			background: white;
			padding: 12px 10px;
			.item-top{
				padding: 2px 0;
				display: flex;
				justify-content: space-between;
				font-size: 12px;
				.top-left{
					color: #666;
					display: flex;
					align-items: center;
				}
				.top-right{
					color: #00d385;
				}
			}
			.item-middle{
				margin-top: 8px;
				display: flex;
				.middle-left{
					width: 80px;
					margin-right: 10px;
				}
				.middle-right{
					line-height: 22px;
					color: #999;
					font-size: 14px;

				}
			}
			.item-bottom{
				width: 100%;
				display: flex;
    		justify-content: end;
				margin-top: 2px;
				.btn{
					width: 100px;
					height: 30px;
					border: none;
					border-radius: 4px;
					background: rgba(19,173,123,1);
				}
			}
		}
	}
	.empty-data{
		text-align: center;
		padding-top: 100px;
		color: #999;
		font-size: 15px;
		line-height: 22px;
	}
	.block{
		background: white;
		padding: 12px 16px;
		margin-bottom: 8px;
	}
	.title-box{
		font-size: 16px;
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		color: #333;
		width: 100%;
		box-sizing: border-box;
		.left{
			width: 90px;
			min-width: 90px;
		}
		.right{
			width: calc(100% - 90px);
			padding-right: 12px;
			line-height: 24px;
		}
	}
	.caution-box{
		font-size: 14px;
		line-height: 26px;
		.tip{
			font-size: 16px;
			color: #fc524f;
			margin-bottom: 2px;
		}
		.key{
			color: #000;
			font-weight: 500;
		}
	}
	.fill-box{
		.section-title{
			padding: 1px 8px;
			border-left: 3px solid #00d385;
			margin-bottom: 10px;
		}
		.item{
			position: relative;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #f5f5f5;
			.label{
				min-width: fit-content;
				width: 96px;
				font-size: 14px;
				color: #323233;
			}
		}
	}
	.btn-box{
		display: flex;
		justify-content: center;
		align-items: center;
		background: white;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		height: 80px;
		border-top: 1px solid #f5f5f5;
		z-index: 10;
		.btn{
			width: 120px;
			border: none;
			background: rgba(19,173,123,1);
		}
	}
}
</style>